// extracted by mini-css-extract-plugin
module.exports = {"err":"articleCategory_err__1m5Ts","ok":"articleCategory_ok__3LPH_"};